// Data
import { regex, countryPincodeValidation } from '../../../../validator/isDataType';
import { REGION } from '../../../../data/idConstants';

export const getCompanyNameRegex = () =>
  regex[process.env.REACT_APP_REGION]?.companyName;

export const getAddressRegex = () => regex[process.env.REACT_APP_REGION]?.address;

const isIndiaRegion = () => process.env.REACT_APP_REGION === REGION.IN.CODE;

export const getAddressLine1DisplayName = () =>
  isIndiaRegion() ? 'Address Line 1' : 'Street Number';

export const getAddressLine2DisplayName = () =>
  isIndiaRegion() ? 'Address Line 2' : 'Street Name';

export const getPinCodeDisplayName = () =>
  isIndiaRegion() ? 'Pin Code' : 'Zip Code';

export const pickupDynamicFields = [
  {
    id: 'pickup-address-section',
    heading: 'Add pickup address',
    className: 'pickup-address-section',
    fields: [
      {
        id: 'warehouse-name',
        name: 'name',
        type: 'TEXT',
        displayName: 'Ware House Name/ Company Name',
        value: '',
        error: '',
        validation: {
          rule: {
            required: { isRequired: true },
            regex: { pattern: getCompanyNameRegex() },
            length: { min: 1, max: 136 }
          }
        }
      },
      {
        id: 'address-line-1',
        name: 'addressLine1',
        type: 'TEXT',
        displayName: getAddressLine1DisplayName(),
        value: '',
        error: '',
        validation: {
          rule: {
            required: { isRequired: true },
            regex: { pattern: getAddressRegex() },
            length: { min: 1, max: 10 }
          }
        }
      },
      {
        id: 'address-line-2',
        name: 'addressLine2',
        type: 'TEXT',
        displayName: getAddressLine2DisplayName(),
        value: '',
        error: '',
        validation: {
          rule: {
            required: { isRequired: true },
            regex: { pattern: getAddressRegex() },
            length: { min: 1, max: 60 }
          }
        }
      },
      {
        id: 'city',
        name: 'city',
        type: 'TEXT',
        displayName: 'City',
        value: '',
        error: '',
        validation: {
          rule: {
            required: { isRequired: true },
            regex: { pattern: getAddressRegex() },
            length: { min: 1, max: 40 }
          }
        }
      },
      {
        id: 'district',
        name: 'district',
        type: 'TEXT',
        displayName: 'District',
        value: '',
        error: '',
        validation: {
          rule: {
            required: { isRequired: true },
            regex: { pattern: getAddressRegex() },
            length: { min: 1, max: 40 }
          }
        }
      },
      {
        id: 'state',
        name: 'state',
        type: 'TEXT',
        displayName: 'State',
        value: '',
        error: '',
        validation: {
          rule: {
            required: { isRequired: true },
            regex: { pattern: getAddressRegex() },
            length: { min: 1, max: 40 }
          }
        }
      },
      {
        id: 'country',
        name: 'country',
        type: 'SINGLE_SELECT_WITH_SEARCH',
        displayName: 'Country',
        value: '',
        error: '',
        placeHolder: 'Select Country',
        options: [],
        validation: {
          rule: {
            required: { isRequired: true }
          }
        }
      },
      {
        id: 'pincode',
        name: 'pincode',
        type: 'TEXT',
        displayName: getPinCodeDisplayName(),
        value: '',
        error: '',
        validation: {
          rule: {
            required: { isRequired: true },
            regex: { pattern: /^\d{6}$/ },
            length: { min: 1, max: 10 }
          },
          countrySpecificValidation: countryPincodeValidation
        }
      },
      {
        id: 'contact-details',
        name: 'contactNo',
        type: 'COMBINE',
        displayName: 'Contact details',
        className: 'contact-row',
        attributes: [
          {
            id: 'isd-code',
            name: 'isdCode',
            type: 'SINGLE_SELECT_WITH_SEARCH',
            displayName: 'Code',
            value: '',
            error: '',
            placeHolder: 'Select code',
            options: [],
            validation: {
              rule: {
                required: { isRequired: true }
              }
            }
          },
          {
            id: 'contact-number',
            name: 'contactNo',
            type: 'TEXT',
            displayName: 'Phone',
            value: '',
            error: '',
            validation: {
              rule: {
                required: { isRequired: true },
                regex: { pattern: regex.telephone }
              }
            }
          }
        ]
      }
    ]
  }
];
